<template>
  <div class="cnfltd-search-results" data-testid="search-results-container">
    <!-- Loading more indicator -->
    <div v-if="isLoadingMore" class="cnfltd-loading-more-banner" data-testid="loading-more-indicator">
      <a-spin size="small" />
      <span>Loading more domain suggestions...</span>
    </div>

    <ResultsTable
      :results="results"
      :currency-symbol="currencySymbol"
      :adding-domain="addingDomain"
      @add-to-cart="handleAddToCart"
    />

    <!-- Show more suggestions button -->
    <div v-if="hasMoreTlds || isLoadingMore" class="cnfltd-load-more">
      <a-button
        type="default"
        size="large"
        :loading="isLoadingMore"
        :disabled="isLoadingMore"
        @click="$emit('loadMore')"
        data-testid="load-more-button"
      >
        {{ isLoadingMore ? 'Loading more suggestions...' : 'Show more suggestions' }}
      </a-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import ResultsTable from './ResultsTable.vue'
import type { DomainSearchResult } from '../types/config'

// Props
interface Props {
  results: DomainSearchResult[]
  currencySymbol?: string
  addingDomain?: string | null
  hasMoreTlds?: boolean
  isLoadingMore?: boolean
}

withDefaults(defineProps<Props>(), {
  currencySymbol: 'R',
  addingDomain: null,
  hasMoreTlds: false,
  isLoadingMore: false
})

// Emits
const emit = defineEmits<{
  addToCart: [domain: string, price: number]
  loadMore: []
}>()

// Handle add to cart event from ResultsTable
const handleAddToCart = (domain: string, price: number) => {
  emit('addToCart', domain, price)
}
</script>

<style scoped>
.cnfltd-search-results {
  margin-top: 2rem;
}

.cnfltd-loading-more-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem;
  margin-bottom: 1rem;
  background: #f0f7ff;
  border: 1px solid #bae0ff;
  border-radius: 4px;
  color: #1890ff;
  font-size: 0.875rem;
}

.cnfltd-load-more {
  margin-top: 1.5rem;
  text-align: center;
  padding: 1rem;
}

.cnfltd-load-more .ant-btn {
  min-width: 200px;
}
</style>
